function PkgReports() {
    return (
      <>
        <div className="font-bold text-xl text-blue-800 mb-16">Pkg Reports</div>
      </>
    );
  }
  
  export default PkgReports;